import { render } from "./ResearchProfileForm.vue?vue&type=template&id=5101d68a"
import script from "./ResearchProfileForm.vue?vue&type=script&lang=js"
export * from "./ResearchProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__